const SiteInfoList = () => import('Views/siteInfo/siteInfo-list');
const SiteInfoDetail = () => import('Views/siteInfo/siteInfo-detail');

export default[
  { path: '/siteInfo-list', component: SiteInfoList },
  { path: '/siteInfo-detail/:id', component: SiteInfoDetail },
];



// WEBPACK FOOTER //
// ./src/router/siteInfo.js